/**
 * Decodes a phone number that was obfuscated server-side by `PhoneCipherHelper.Encode`.
 * Each digit was shifted by `shift` (mod 10); this reverses that shift.
 * Non-digit characters are left untouched.
 *
 * @param {string} encoded - The ciphered phone number.
 * @param {number|string} shift - The shift amount used to encode the phone number.
 * @returns {string} The decoded phone number, or the original value if it can't be decoded.
 */
export const decode = (encoded, shift) => {
  if (encoded === null || typeof encoded === 'undefined' || encoded === '') {
    return encoded;
  }

  const parsedShift = parseInt(shift, 10);
  if (Number.isNaN(parsedShift)) {
    return encoded;
  }

  const normalizedShift = ((parsedShift % 10) + 10) % 10;

  return `${encoded}`.replace(/\d/g, (digit) => {
    const decodedDigit = (parseInt(digit, 10) - normalizedShift + 10) % 10;
    return `${decodedDigit}`;
  });
};

export default decode;
